import type { ComponentType, ReactNode } from "react";

export function RegulationSectionPage({
  title,
  description,
  emptyIcon: EmptyIcon,
  emptyTitle,
  emptyBody,
  children,
  aside,
  actions,
}: {
  title: string;
  description: string;
  emptyIcon: ComponentType<{ className?: string }>;
  emptyTitle: string;
  emptyBody: string;
  children?: ReactNode;
  /** Page-level control (a setting this page owns), under the heading. */
  aside?: ReactNode;
  /** Primary action for the page, aligned with the title. */
  actions?: ReactNode;
}) {
  return (
    <div className="regulation-page-scroll-fade min-h-0 flex-1 overflow-y-auto">
      <div className="w-full px-5 py-8 sm:px-8">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0">
            <h1 className="text-lg font-semibold text-foreground">{title}</h1>
            <p className="mt-1 text-sm text-muted-foreground">{description}</p>
          </div>
          {actions ? <div className="shrink-0">{actions}</div> : null}
        </div>
        {aside}
        {children ?? (
          <div className="mt-8 flex flex-col items-center rounded-xl border border-dashed px-6 py-16 text-center">
            <EmptyIcon className="size-5 text-muted-foreground/60" />
            <p className="mt-3 text-sm font-medium text-foreground">{emptyTitle}</p>
            <p className="mt-1 max-w-sm text-sm text-muted-foreground">{emptyBody}</p>
          </div>
        )}
      </div>
    </div>
  );
}
